<template>
  <mdb-navbar class="orange darken-1" dark>
    <mdb-navbar-brand>
      <router-link :to="{name:'about'}">
        <div class="logo">
          <img src="/android-chrome-192x192.png" alt="please be true"/>
        </div>
        Please be true
      </router-link>
    </mdb-navbar-brand>
    <mdb-navbar-toggler>
      <mdb-navbar-nav>
        <router-link :to="{name:'home'}" v-if="user">
          <mdb-nav-item>Accueil</mdb-nav-item>
        </router-link>
        <router-link :to="{name:'contacts'}" v-if="user">
          <mdb-nav-item>Contacts</mdb-nav-item>
        </router-link>
        <router-link :to="{name:'myConversations'}" v-if="user">
          <mdb-nav-item>Conversations</mdb-nav-item>
        </router-link>
        <router-link :to="{name:'allQuestions'}" v-if="user">
          <mdb-nav-item>Questions</mdb-nav-item>
        </router-link>
      </mdb-navbar-nav>

      <mdb-dropdown v-if="user" tag="li" class="nav-item" btn-group dropleft>
        <mdb-dropdown-toggle tag="a" navLink dark slot="toggle" waves-fixed>
          <span class="material-icons account">account_circle</span>
        </mdb-dropdown-toggle>
        <mdb-dropdown-menu class="brown lighten-1">
          <!--
          <mdb-dropdown-item class="brown lighten-1" @click="goToContacts">Mes contacts</mdb-dropdown-item>
          <div class="dropdown-divider"></div>-->
          <mdb-dropdown-item class="orange darken-1" @click="logout">Logout</mdb-dropdown-item>
          <mdb-dropdown-item class="orange darken-1" @click="deleteUser">Supprimer mon compte</mdb-dropdown-item>
        </mdb-dropdown-menu>
      </mdb-dropdown>
      <div
        v-if="$store.state.db.user && $store.state.db.user.displayName"
        class="navbar-text"
      >{{$store.state.db.user.displayName}}</div>
      <mdb-btn class="brown lighten-1" rounded v-if="!user" @click="login">S'identifier</mdb-btn>
    </mdb-navbar-toggler>
  </mdb-navbar>
</template>
<script>
import {
  mdbNavbar,
  mdbNavbarBrand,
  mdbNavbarToggler,
  mdbNavbarNav,
  mdbNavItem,
  mdbDropdown,
  mdbDropdownToggle,
  mdbDropdownItem,
  mdbDropdownMenu
} from "mdbvue";
import { mapState } from "vuex";
import Swal from 'sweetalert2'

export default {
  name: "Nav",
  components: {
    mdbNavbar,
    mdbNavbarBrand,
    mdbNavbarToggler,
    mdbNavbarNav,
    mdbNavItem,
    mdbDropdown,
    mdbDropdownToggle,
    mdbDropdownItem,
    mdbDropdownMenu
  },
  computed: mapState("auth", ["user"]),
  methods: {
    logout: function() {
      this.$store.dispatch("auth/logout");
      if (this.$router.currentRoute.name != "about")
        this.$router.push({ name: "about" });
    },
    login: function() {
      if (this.$router.currentRoute.name != "login")
        this.$router.push({ name: "login" });
    },
    deleteUser: async function() {
      let done = await this.$store.dispatch("db/deleteUser");
      if (!done) {
        Swal.fire({
          title:
            "Vos données ont été supprimées",
          text:
            "Vous devez vous reconnecter et re-cliquer sur supprimer mon compte afin de pourvoir finaliser la suppression de votre compte. Vérifiez que tout a bien été supprimé, et n'hésitez pas à envoyer un mail à info@dbloke si ce n'est pas le cas.",
          icon: "warning",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Se reconnecter"
        }).then(result => {
           this.$store.dispatch("auth/logout");
           this.$router.push({ name: "login" });
        });
      } else {
        Swal.fire({
          title:
            "Il ne reste plus rien",
          text:
            "Vous avez complètement été supprimé de notre base de donnée",
          icon: "info",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Au revoir"
        }).then(result => {
        });
      }
      if (this.$router.currentRoute.name != "about")
        this.$router.push({ name: "about" });
    },
    /*
    goToContacts: function() {
      if (this.$router.currentRoute.name != "contacts")
        this.$router.push({ name: "contacts" });
    }
    */
  }
};
</script>
<style lang="scss">
nav {
  a,
  a:hover,
  .dropdown-toggle::after {
    color: white;
  }
  .account {
    font-size: 30px;
    color: white;
  }
}
.logo{
  display: inline-block;
  height:50px;
  width: 50px;
  background-color: rgba(255, 255, 255, 0.473);
  padding:10px;
  border-radius: 10px;
  img{
    height: 100%;
    width: 100%;
  }
}
</style>